import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/styles.css';

export default function Welcome() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [menuActive, setMenuActive] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const [headerScrolled, setHeaderScrolled] = useState(false);
  const [headerHidden, setHeaderHidden] = useState(false);
  
  // Handle header scroll behavior
  useEffect(() => {
    let lastScrollY = window.scrollY;
    let scrollingDown = false;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > 70) {
        setHeaderScrolled(true);
        
        if (currentScrollY > lastScrollY && !scrollingDown) {
          scrollingDown = true;
          setHeaderHidden(true);
        } else if (currentScrollY < lastScrollY && scrollingDown) {
          scrollingDown = false;
          setHeaderHidden(false);
        }
      } else {
        setHeaderScrolled(false);
      }
      
      lastScrollY = currentScrollY;
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % 3);
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);
  
  // Show modal after delay
  useEffect(() => {
    const timeout = setTimeout(() => {
      setModalActive(true);
    }, 3000);
    
    return () => clearTimeout(timeout);
  }, []);
  
  // Handle menu toggle
  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };
  
  // Handle testimonial dot click
  const handleTestimonialDotClick = (index : any) => {
    setCurrentTestimonial(index);
  };
  
  // Close modal
  const closeModal = () => {
    setModalActive(false);
  };

  return (
    <>
      <header className={`main-header ${headerScrolled ? 'scrolled' : ''} ${headerHidden ? 'hidden' : ''}`}>
        <div className="header-container">
          <Link to="/" className="logo-container">
            <img src="/images/logo faucon bleu.png" alt="Faucon Bleu Logo" className="logo" />
          </Link>
          <nav className="main-nav">
            <button 
              className={`menu-toggle ${menuActive ? 'active' : ''}`}
              aria-label="Toggle Menu"
              onClick={toggleMenu}
            >
              <span className="bar" style={menuActive ? {transform: 'rotate(-45deg) translate(-5px, 6px)'} : {}}></span>
              <span className="bar" style={menuActive ? {opacity: '0'} : {}}></span>
              <span className="bar" style={menuActive ? {transform: 'rotate(45deg) translate(-5px, -6px)'} : {}}></span>
            </button>
            <ul className={`nav-menu ${menuActive ? 'active' : ''}`}>
              <li><Link to="/" className="active">Accueil</Link></li>
              <li><Link to="/discover">Nos Services</Link></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </nav>
        </div>
      </header>
      
      <main>
        <section className="hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Vos voitures entre de bonnes mains, où que vous soyez</h1>
            <p className="hero-subtitle">Atelier mobile, service à domicile et centre technique à Bouskoura</p>
            <div className="hero-cta">
              <Link to="/reservation" className="btn btn-primary">Simulez votre vidange</Link>
              <Link to="/discover" className="btn btn-secondary">Découvrir nos services</Link>
            </div>
          </div>
        </section>

        <section className="featured-services">
          <div className="container">
            <h2 className="section-title">Services Automobiles sur Mesure</h2>
            <div className="services-grid">
              <div className="service-card">
                <div className="service-icon">
                  <i className="fas fa-tools"></i>
                </div>
                <h3>Atelier Mobile</h3>
                <p>Vidange et entretien à domicile ou sur votre lieu de travail.</p>
                <Link to="/discover" className="service-link">En savoir plus</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <i className="fas fa-car"></i>
                </div>
                <h3>Centre Technique</h3>
                <p>Réparations avancées dans notre atelier moderne à Bouskoura.</p>
                <Link to="/discover" className="service-link">En savoir plus</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <i className="fas fa-cogs"></i>
                </div>
                <h3>Maintenance Préventive</h3>
                <p>Diagnostic et suivi personnalisé pour chaque véhicule.</p>
                <Link to="/discover" className="service-link">En savoir plus</Link>
              </div>
            </div>
          </div>
        </section>

        <section className="testimonials">
          <div className="container">
            <h2 className="section-title">Ce que disent nos clients</h2>
            <div className="testimonial-slider">
              <div className={`testimonial-slide ${currentTestimonial === 0 ? 'active' : ''}`}>
                <div className="testimonial-content">
                  <div className="testimonial-stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </div>
                  <p>"Service impeccable ! Le technicien est venu directement à mon domicile et a effectué une vidange parfaite en moins de 30 minutes."</p>
                  <div className="testimonial-author">Ahmed K.</div>
                </div>
              </div>
              <div className={`testimonial-slide ${currentTestimonial === 1 ? 'active' : ''}`}>
                <div className="testimonial-content">
                  <div className="testimonial-stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </div>
                  <p>"L'application mobile est vraiment pratique ! Je peux suivre l'historique de maintenance de toutes mes voitures et recevoir des rappels."</p>
                  <div className="testimonial-author">Sophia M.</div>
                </div>
              </div>
              <div className={`testimonial-slide ${currentTestimonial === 2 ? 'active' : ''}`}>
                <div className="testimonial-content">
                  <div className="testimonial-stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                  </div>
                  <p>"L'atelier à Bouskoura est moderne et propre. Mon véhicule a été pris en charge rapidement et le café-resto sur place est un vrai plus !"</p>
                  <div className="testimonial-author">Karim B.</div>
                </div>
              </div>
            </div>
            <div className="testimonial-controls">
              <button 
                className={`testimonial-dot ${currentTestimonial === 0 ? 'active' : ''}`} 
                onClick={() => handleTestimonialDotClick(0)}
                aria-label="Témoignage 1"
              ></button>
              <button 
                className={`testimonial-dot ${currentTestimonial === 1 ? 'active' : ''}`} 
                onClick={() => handleTestimonialDotClick(1)}
                aria-label="Témoignage 2"
              ></button>
              <button 
                className={`testimonial-dot ${currentTestimonial === 2 ? 'active' : ''}`} 
                onClick={() => handleTestimonialDotClick(2)}
                aria-label="Témoignage 3"
              ></button>
            </div>
          </div>
        </section>
      </main>

      <footer id="contact" className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src="/images/logo faucon bleu.png" alt="Faucon Bleu Logo" loading="lazy" />
            </div>
            <div className="footer-contact">
              <h3>Contact</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <i className="fas fa-phone-alt"></i>
                  <div>
                    <p>07 02 09 45 93</p>
                    <p>06 08 11 26 26</p>
                  </div>
                </div>
                <div className="contact-item">
                  <i className="fas fa-envelope"></i>
                  <div>
                    <p><a href="mailto:contact@faucon-bleu.ma">contact@faucon-bleu.ma</a></p>
                  </div>
                </div>
                <div className="contact-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <div>
                    <p>Atelier de Bouskoura</p>
                    <p>Zone Industrielle, Bouskoura</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-social">
              <h3>Suivez-nous</h3>
              <div className="social-links">
                <a href="#" target="_blank" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                <a href="#" target="_blank" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="#" target="_blank" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Faucon Bleu. Tous droits réservés.</p>
          </div>
        </div>
      </footer>

      <div className={`modal ${modalActive ? 'active' : ''}`} id="promoModal">
        <div className="modal-content">
          <button className="close-modal" aria-label="Fermer" onClick={closeModal}>
            <i className="fas fa-times"></i>
          </button>
          <div className="modal-body">
            <img src="/images/shell huile vidange.png" alt="Promotion vidange Shell" loading="lazy" />
          </div>
        </div>
      </div>
    </>
  );
}